import { FallbackProps } from 'react-error-boundary';
import { ErrorPage } from '../../main/components/CustomErrorPages/ErrorPage';

export function GeneralErrorFallback(props: FallbackProps) {
  return <ErrorPage resetErrorBoundary={props.resetErrorBoundary} />;
}
